import angular from 'angular'

import component from './my-rlink-model.component'

let module = angular.module('myRlinkModel', [])

.component('myRlinkModel', component)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/my-rlink-model/index.js